import React, { useRef, useCallback, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import "@/App.css";
import { LangProvider } from "./i18n/LangProvider";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Histoire from "./components/Histoire";
import Story from "./components/Story";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Reservation from "./components/Reservation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Maintenance from "./components/Maintenance";
import { Toaster } from "./components/ui/sonner";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const reservationRef = useRef(null);
  const [settings, setSettings] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/settings`);
        if (!cancelled) setSettings(res.data);
      } catch (err) {
        console.error("Failed to load settings", err);
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const scrollToReservation = useCallback(() => {
    const el = document.getElementById("reservation");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  const scrollToMenu = useCallback(() => {
    const el = document.getElementById("menu");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  if (!checked) {
    return <div className="min-h-screen bg-obsidian" data-testid="loading" />;
  }

  if (settings?.maintenance_mode) {
    return <Maintenance settings={settings} />;
  }

  return (
    <div className="bg-obsidian min-h-screen text-ivory" data-testid="home-page">
      <Navbar onReserveClick={scrollToReservation} />
      <Hero onReserveClick={scrollToReservation} onMenuClick={scrollToMenu} />
      <Histoire />
      <Story />
      <Menu />
      <Gallery />
      <Reservation ref={reservationRef} enabled={settings?.reservations_enabled !== false} />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
};

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("grizzly_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <LangProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminDashboard />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}

export default App;
